<button class="back-button" type="button" (click)="onClick()">
  <app-icon
    class="back-button__icon"
    name="chevron-left"
    [size]="16"
    color="currentColor"
    aria-hidden="true"
  />
  <span class="back-button__label">{{ label() | translateLang }}</span>
</button>
